import type { HierarchyPathItem } from '@shared/gql/document-nodes'
import type { BreadCrumbItem } from 'components/Breadcrumb'
import type { FC } from 'react'

import { Breadcrumb } from 'components/Breadcrumb'
import { useMemo } from 'react'

interface Props {
  hierarchyPath?: Pick<HierarchyPathItem, 'id' | 'name' | 'slug'>[] | null
}

export const ProductPageBreadcrumb: FC<Props> = ({ hierarchyPath }) => {
  const breadcrumbItems = useMemo<BreadCrumbItem[]>(
    () =>
      hierarchyPath
        ?.map((path) => ({
          id: path.id,
          name: path.name,
          slug: path.slug,
          href: '/tuotteet/[...slugs]',
          link: `/tuotteet/${path?.slug}`,
        }))
        .reverse() || [],
    [hierarchyPath],
  )

  return <Breadcrumb items={breadcrumbItems} />
}
